import { format, Locale } from 'date-fns';

export const registerLocaleInit = async () => {
  const { registerLocale } = await import('react-datepicker');
  const { default: ru } = await import('date-fns/locale/ru');
  registerLocale('ru', ru as unknown as Locale);
};

export const getRangeLabel = ({
  range,
  showYear = false,
}: {
  range: [null | Date | undefined, null | Date | undefined];
  showYear?: boolean;
}) => {
  const [startDate, endDate] = range;
  const defaultFormat = showYear ? 'dd.MM.yyyy' : 'dd.MM';

  if (!startDate && !endDate) return '';

  const parsedStart = startDate && format(startDate, defaultFormat);
  const parsedEnd = endDate && format(endDate, defaultFormat);

  return [parsedStart, parsedEnd].join(' — ');
};
